<template>
  <div>
    <b-container v-if="loading" class="text-center">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </b-container>
    <b-container v-if="!loading" class="conta">
      <b-row>
        <b-col>
          <p class="h2">Solicitud de Incorporación al Registro Electoral</p>
        </b-col>
      </b-row>

      <div class="item1">
        <b-row>
          <b-col> <legend>1.- DATOS DEL SOLICITANTE</legend> </b-col>
        </b-row>
        <hr class="mt-0 mb-0" />
        <b-row>
          <b-col sm="6">
            <b-form-group label="RUN">
              <b-form-input
                disabled
                v-model="formPersonal.run"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Nombres">
              <b-form-input
                :class="{ 'is-invalid': $v.formPersonal.nombres.$invalid }"
                v-model="formPersonal.nombres"
                type="text"
                required
              ></b-form-input>
              <p
                v-if="!$v.formPersonal.nombres.required"
                class="invalid-feedback mb-0"
              >
                El campo Nombres es requerido
              </p>
            </b-form-group>
            <p></p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Primer Apellido">
              <b-form-input
                :class="{
                  'is-invalid': $v.formPersonal.apellido_paterno.$invalid,
                }"
                v-model="formPersonal.apellido_paterno"
                type="text"
                required
              ></b-form-input>
              <p
                v-if="!$v.formPersonal.apellido_paterno.required"
                class="invalid-feedback mb-0"
              >
                El campo Primer Apellido es requerido
              </p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Segundo Apellido">
              <b-form-input
                :class="{
                  'is-invalid': $v.formPersonal.apellido_materno.$invalid,
                }"
                v-model="formPersonal.apellido_materno"
                type="text"
                required
              ></b-form-input>
              <p
                v-if="!$v.formPersonal.apellido_materno.required"
                class="invalid-feedback mb-0"
              >
                El campo Segundo Apellido es requerido
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Fecha Nacimiento">
              <b-form-datepicker
                :class="{
                  'is-invalid': $v.formPersonal.fecha_nacimiento.$invalid,
                }"
                v-model="formPersonal.fecha_nacimiento"
                :max="max"
                :no-flip="true"
                locale="es"
                placeholder="Seleccionar fecha"
              >
              </b-form-datepicker>
              <p
                v-if="!$v.formPersonal.fecha_nacimiento.required"
                class="invalid-feedback mb-0"
              >
                La fecha de nacimiento es requerida
              </p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <!-- <b-form-group label="Nacionalidad">
              <b-form-checkbox
                v-model="formPersonal.is_chileno"
                switch
                size="lg"
              >
                <strong v-if="formPersonal.is_chileno">CHILENA</strong>
                <strong v-if="!formPersonal.is_chileno">EXTRANJERO</strong>
              </b-form-checkbox>
            </b-form-group> -->
            <b-form-group label="Nacionalidad" v-slot="{ nacionalidad }">
              <b-form-radio-group
                id="nacionalidad"
                v-model="formPersonal.is_chileno"
                :aria-describedby="nacionalidad"
                name="nacionalidad-radio"
                :class="{
                  'is-invalid': $v.formPersonal.is_chileno.$invalid,
                }"
              >
                <b-form-radio v-bind:value="true">CHILENA</b-form-radio>
                <b-form-radio v-bind:value="false"
                  >EXTRANJERO</b-form-radio
                ></b-form-radio-group
              >
              <p
                v-if="!$v.formPersonal.is_chileno.required"
                class="invalid-feedback mb-0"
              >
                La nacionalidad es requerida
              </p>
            </b-form-group></b-col
          >
        </b-row>
        <div v-if="formPersonal.is_chileno === false">
          <b-row>
            <b-col sm="6">
              <b-form-group label="Correo Electrónico">
                <b-form-input
                  :class="{ 'is-invalid': $v.formComun.email.$invalid }"
                  v-model="formComun.email"
                  type="text"
                  placeholder="Ingresar Email"
                  required
                  @paste.prevent
                ></b-form-input>
                <p
                  v-if="!$v.formComun.email.maxLength"
                  class="invalid-feedback mb-0"
                >
                  El maximo permitido es de 50 caracteres
                </p>
                <p
                  v-if="!$v.formComun.email.required"
                  class="invalid-feedback mb-0"
                >
                  El correo es requerido
                </p>
                <p
                  v-if="!$v.formComun.email.email"
                  class="invalid-feedback mb-0"
                >
                  Formato de correo incorrecto
                </p>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Confirmar Correo Electrónico">
                <b-form-input
                  :class="{ 'is-invalid': $v.formComun.email2.$invalid }"
                  v-model="formComun.email2"
                  type="text"
                  placeholder="Ingresar Email"
                  required
                  @paste.prevent
                ></b-form-input>
                <p
                  v-if="!$v.formComun.email2.required"
                  class="invalid-feedback mb-0"
                >
                  Confirmar correo es requerido
                </p>
                <p
                  v-if="!$v.formComun.email2.email"
                  class="invalid-feedback mb-0"
                >
                  Formato de correo incorrecto
                </p>
                <p
                  v-if="!$v.formComun.email2.sameAs"
                  class="invalid-feedback mb-0"
                >
                  Los correos no son iguales
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Teléfono">
                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input-group-prepend is-text>
                    <strong>{{
                      ubicacion === "extranjero" ? "+" : "+56"
                    }}</strong>
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{ 'is-invalid': $v.formComun.telefono.$invalid }"
                    v-model="formComun.telefono"
                    type="text"
                    :placeholder="
                      ubicacion === 'extranjero'
                        ? 'Ej:5622222222'
                        : 'Ej:22222222'
                    "
                    required
                    @change="validarTelefono"
                  >
                  </b-form-input
                ></b-input-group>
                <p
                  v-if="!$v.formComun.telefono.required"
                  class="invalid-feedback mb-0"
                >
                  El Teléfono es requerido
                </p>
                <p
                  v-if="!$v.formComun.telefono.maxLength"
                  class="invalid-feedback mb-0"
                >
                  El maximo permitido es de 12 caracteres
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <!-- <b-row>
          <b-col sm="6">
            <b-form-group label="Pais de Nacimiento">
              <model-list-select
                :isError="$v.formPersonal.pais_nacimiento.$invalid"
                v-model="formPersonal.pais_nacimiento"
                :list="paises_personal"
                option-value="cod_pais"
                option-text="pais"
                placeholder="seleccionar pais"
              >
              </model-list-select>
            </b-form-group>
          </b-col>
        </b-row> -->

        <div v-if="formPersonal.is_chileno">
          <DomicilioElectoral
            v-bind:otrasValidaciones="$v.formPersonal.$invalid"
            v-bind:incorporacion="true"
            v-bind:nacionalidad="formPersonal.is_chileno"
            v-bind:ischile="formPersonal.pais_nacimiento"
            v-bind:run="formPersonal.run"
            v-bind:dv="formPersonal.dv"
            v-on:sendToForm="sendToForm"
          >
          </DomicilioElectoral>
        </div>
        <div v-else-if="formPersonal.is_chileno === false">
          <DomicilioElectoralExtranjero
            v-bind:otrasValidaciones="$v.formPersonal.$invalid"
            v-bind:incorporacion="true"
            v-bind:nacionalidad="formPersonal.is_chileno"
            v-bind:ischile="formPersonal.pais_nacimiento"
            v-bind:run="formPersonal.run"
            v-bind:dv="formPersonal.dv"
            v-on:sendToForm="sendToForm"
          >
          </DomicilioElectoralExtranjero>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  maxLength,
  minLength,
  numeric,
  sameAs,
  email,
} from "vuelidate/lib/validators";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import DomicilioElectoral from "./partials/DomicilioElectoral";
import router from "./../router";
import Swal from "sweetalert2";

import { mapState, mapActions } from "vuex";
import DomicilioElectoralExtranjero from "./partials/DomicilioElectoralExtranjero.vue";

const computed = {
  ...mapState("domicilio", [
    "formChileGeo",
    "formChileUrbano",
    "formChileRural",
    "formExtranjero",
    "formAvecindamiento",
    "formComun",
    "ubicacion",
    "paises_personal",
    `paises`,
    `regiones`,
    `territorios`,
    `circunscripciones`,
    `ciudades`,
    `comunas`,
  ]),
};

const watch = {
  "formPersonal.is_chileno": async function (val) {
    // this.chanchePaisPersonal(val);

    if (val) this.formPersonal.pais_nacimiento = "CL";

    if (!val) this.formPersonal.pais_nacimiento = "";
  },
};

export default {
  name: "Incorporacion",
  components: {
    // ModelListSelect,
    DomicilioElectoral,
    DomicilioElectoralExtranjero,
  },
  computed,
  watch,
  data: function () {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const maxDate = new Date(today);

    maxDate.setMonth(today.getMonth() - 204);

    return {
      max: maxDate,
      loading: true,
      formPersonal: {
        run: null,
        dv: null,
        nombres: null,
        fecha_nacimiento: null,
        apellido_paterno: null,
        apellido_materno: null,
        is_chileno: null,
        pais_nacimiento: null,
      },
    };
  },
  validations: {
    ubicacion: { required },
    formPersonal: {
      run: { required },
      nombres: { required },
      apellido_paterno: { required },
      apellido_materno: { required },
      is_chileno: { required },
      // pais_nacimiento: { required },
      fecha_nacimiento: { required },
    },
    formComun: {
      email: { required, email, maxLength: maxLength(50) },
      email2: { required, email, sameAs: sameAs("email") },
      telefono: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(12),
        numeric,
      },
      nDocumento: { required, maxLength: maxLength(9) },
    },
  },

  async mounted() {
    console.log("cargando el modulo");
    const run = localStorage.getItem(
      `CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.LastAuthUser`,
    );
    console.log(
      "run",
      localStorage.getItem(
        `CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.LastAuthUser`,
      ),
    );
    this.formPersonal.pais_nacimiento = "CL";

    let array_run;
    let run_number;
    if (run.length > 10) {
      array_run = run.split("_");
      run_number = array_run[1];
    } else {
      run_number;
      array_run = run.split("-");
      run_number = array_run[0];
    }

    if (array_run.length > 0) {
      this.formPersonal.run = run_number;
    }

    this.formPersonal.dv = await this.verificarDV(this.formPersonal.run);

    this.loading = false;
  },
  methods: {
    ...mapActions("domicilio", ["chanchePaisPersonal"]),
    ...mapActions("solicitud", ["setIncorporacion", "setFolio"]),

    async verificarDV(run) {
      let M = 0;
      let S = 1;
      for (; run; run = Math.floor(run / 10))
        S = (S + (run % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },

    async validarTelefono(e) {
      if (!/^[0-9]*$/.test(e)) {
        Swal.fire({
          icon: "error",
          type: "error",
          text: "El campo Teléfono solo debe ingresar números",
          confirmButtonText: "Aceptar",
        });
      }
    },

    async sendToForm() {
      this.loading = true;

      try {
        const url = `${process.env.VUE_APP_API_URL}/setsolicitud`;

        // https://api.servel.cl/cdomi/setsolicitud
        const payload = {};

        // comunes
        payload.email = this.formComun.email;
        payload.telefono = this.formComun.telefono;
        payload.incorporacion = true;

        payload.calle = null;
        payload.numero = null;
        payload.resto = null;
        payload.origen = null;
        payload.cod_ubicacion = null;
        payload.cod_pais = null;
        payload.cod_region = null;
        payload.cod_comuna = null;
        payload.cod_circunscripcion = null;
        payload.localidad = null;
        payload.cod_consulado = null;
        payload.codigopostal = null;
        payload.mapa = this.formComun.screenshot;

        payload.run = this.formPersonal.run;
        payload.fecha_nacimiento = this.formPersonal.fecha_nacimiento;
        payload.nombres = this.formPersonal.nombres;
        payload.paterno = this.formPersonal.apellido_paterno;
        payload.materno = this.formPersonal.apellido_materno;
        payload.nacionalidad = this.formPersonal.is_chileno
          ? "CHILENO"
          : "EXTRANJERO";
        payload.cod_paisnacimiento = this.formPersonal.pais_nacimiento;
        payload.paisnacimiento = payload.cod_paisnacimiento
          ? this.paises_personal.find(
              (pa) => pa.cod_pais == payload.cod_paisnacimiento,
            ).pais
          : null;

        let htmlConfirm = `
                    <table class="table striped">
                        <tbody > 
                            `;

        if (this.formPersonal.is_chileno === false) {
          payload.observaciones = this.formAvecindamiento.observaciones;
          payload.avecindamiento = this.formAvecindamiento.avecindamiento;
          htmlConfirm += `
                            <tr>
                                <td>Observaciones</td>
                                <td>${payload.observaciones}</td>
                            </tr>`;

          htmlConfirm += `
                            <tr>
                                <td>Más de 10 años en Chile</td>
                                <td>${payload.avecindamiento ? "SI" : "NO"}</td>
                            </tr>`;
        }

        if (this.ubicacion == "chile-geo") {
          payload.cod_region = this.formChileGeo.cod_region;
          payload.cod_comuna = this.formChileGeo.cod_comuna;
          payload.region = this.formChileGeo.region_nom;
          payload.comuna = this.formChileGeo.comuna;
          payload.cod_pais = "CL";
          payload.pais = "CHILE";
          payload.calle = this.formChileGeo.geo_calle;
          payload.numero = this.formChileGeo.geo_numero;
          payload.resto = this.formChileGeo.tipo_residencia
            ? `${this.formChileGeo.tipo_residencia} ${this.formChileGeo.block_depto}`
            : this.formChileGeo.block_depto;
          payload.cod_ubicacion = "UG";
          payload.geo = this.formChileGeo.geo;
          payload.notificacion_correo =
            this.formChileUrbano.notificacion_correo;
          payload.reponse_google = this.formChileGeo.respuesta_google;
          payload.telefono = "+56" + this.formComun.telefono;
          payload.origen_coord = this.formChileGeo.origen;

          htmlConfirm += `
                            <tr>
                                <td>País</td>
                                <td>${this.formChileGeo.direccion_estandar.pais}</td>
                            </tr>`;
          htmlConfirm += `
                            <tr>
                                <td>Región</td>
                                <td>${this.formChileGeo.region_nom}</td>
                            </tr>`;
          htmlConfirm += `
                            <tr>
                                <td>Comuna</td>
                                <td>${this.formChileGeo.comuna}</td>
                            </tr>`;
          htmlConfirm += `
                            <tr>
                                <td>Calle</td>
                                <td>${this.formChileGeo.direccion_estandar.calle}</td>
                            </tr>`;
          htmlConfirm += ` 
                            <tr>
                                <td>Otra Información</td>
                                <td>${payload.resto || ""}</td>
                            </tr>`;

          let notifi = payload.notificacion_correo ? "SI" : "NO";

          htmlConfirm += ` 
                            <tr>
                                <td>Notificación digital</td>
                                <td>${notifi}</td>
                            </tr>`;
        }
        if (this.ubicacion == "chile-urbano") {
          payload.cod_pais = "CL";
          payload.pais = "CHILE";
          payload.cod_region = this.formChileUrbano.region;
          payload.cod_comuna = this.formChileUrbano.comuna;
          payload.localidad = this.formChileUrbano.villa_poblacion;
          payload.calle = this.formChileUrbano.calle;
          payload.numero = this.formChileUrbano.numero;
          //   payload.resto = this.formChileUrbano.block_depto;
          payload.resto = this.formChileUrbano.tipo_residencia
            ? `${this.formChileUrbano.tipo_residencia} ${this.formChileUrbano.block_depto}`
            : this.formChileUrbano.block_depto;
          payload.notificacion_correo =
            this.formChileUrbano.notificacion_correo;
          payload.region = this.regiones.find(
            (reg) => reg.cod_region == payload.cod_region,
          ).region;
          payload.comuna = this.comunas.find(
            (com) => com.cod_comuna == payload.cod_comuna,
          ).comuna;
          payload.cod_ubicacion = "U";
          payload.telefono = "+56" + this.formComun.telefono;
          payload.geo = this.formChileUrbano.geo;
          payload.origen_coord = this.formChileUrbano.origen;
          payload.cod_localidad = this.formChileUrbano.cod_localidad;

          htmlConfirm += `
                            <tr>
                                <td>Región</td>
                                <td>${payload.region}</td>
                            </tr>`;

          htmlConfirm += `
                            <tr>
                                <td>Comuna</td>
                                <td>${payload.comuna}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Calle</td>
                                <td>${payload.calle || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Número</td>
                                <td>${payload.numero || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Otra Información</td>
                                <td>${payload.resto || ""}</td>
                            </tr>`;

          let notifi = payload.notificacion_correo ? "SI" : "NO";

          htmlConfirm += ` 
                            <tr>
                                <td>Notificación digital</td>
                                <td>${notifi}</td>
                            </tr>`;
        }
        if (this.ubicacion == "chile-rural") {
          payload.cod_pais = "CL";
          payload.pais = "CHILE";
          payload.cod_region = this.formChileRural.region;
          payload.cod_comuna = this.formChileRural.comuna;
          payload.localidad = this.formChileRural.localidad;
          payload.calle = this.formChileRural.calle;
          payload.numero = this.formChileRural.numero;
          payload.notificacion_correo =
            this.formChileUrbano.notificacion_correo;
          payload.region = this.regiones.find(
            (reg) => reg.cod_region == payload.cod_region,
          ).region;
          payload.comuna = this.comunas.find(
            (com) => com.cod_comuna == payload.cod_comuna,
          ).comuna;
          payload.cod_ubicacion = "R";
          payload.telefono = "+56" + this.formComun.telefono;
          payload.geo = this.formChileRural.geo;
          payload.origen_coord = this.formChileRural.origen;
          payload.cod_localidad = this.formChileRural.cod_localidad;

          htmlConfirm += `
                            <tr>
                                <td>Región</td>
                                <td>${payload.region}</td>
                            </tr>`;

          htmlConfirm += `
                            <tr>
                                <td>Comuna</td>
                                <td>${payload.comuna}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Calle</td>
                                <td>${payload.calle || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Número</td>
                                <td>${payload.numero || ""}</td>
                            </tr>`;

          let notifi = payload.notificacion_correo ? "SI" : "NO";

          htmlConfirm += ` 
                            <tr>
                                <td>Notificación digital</td>
                                <td>${notifi}</td>
                            </tr>`;
        }

        if (this.ubicacion == "extranjero") {
          payload.cod_pais = this.formExtranjero.pais;
          payload.pais = this.paises.find(
            (pa) => pa.cod_pais == payload.cod_pais,
          ).pais;
          payload.cod_region = this.formExtranjero.division_territorial;
          payload.region = this.territorios.find(
            (reg) => reg.cod_region == payload.cod_region,
          ).region;
          payload.cod_comuna = this.formExtranjero.ciudad;
          payload.comuna = this.ciudades.find(
            (com) => com.cod_comuna == payload.cod_comuna,
          ).comuna;
          payload.calle = this.formExtranjero.calle;
          payload.numero = this.formExtranjero.numero;
          payload.codigopostal = this.formExtranjero.codigo_postal;
          payload.cod_circunscripcion = this.formExtranjero.circunscripcion;
          payload.circunscripcion = this.circunscripciones.find(
            (cir) => cir.cod_circunscripcion == payload.cod_circunscripcion,
          ).circunscripcion;
          payload.notificacion_correo = true;
          payload.cod_ubicacion = "E";
          payload.telefono = "+" + this.formComun.telefono;
          payload.resto = this.formExtranjero.block_depto;

          htmlConfirm += `
                            <tr>
                                <td>País</td>
                                <td>${payload.pais}</td>
                            </tr>`;

          htmlConfirm += `
                            <tr>
                                <td>División Territorial</td>
                                <td>${payload.region}</td>
                            </tr>`;

          htmlConfirm += `
                            <tr>
                                <td>Ciudad</td>
                                <td>${payload.comuna}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Calle</td>
                                <td>${payload.calle || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Número</td>
                                <td>${payload.numero || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Código Postal</td>
                                <td>${payload.codigopostal || ""}</td>
                            </tr>`;

          htmlConfirm += ` 
                            <tr>
                                <td>Nombre del Block / Departamento</td>
                                <td>${payload.resto || ""}</td>
                            </tr>`;
        }

        htmlConfirm += ` 
                            <tr>
                                <td>Correo electrónico</td>
                                <td>${payload.email}</td>
                            </tr> 
                            <tr>
                                <td>Teléfono</td>
                                <td>${payload.telefono}</td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div>
                                    <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="status"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                    >
                                    Declaro que estos datos son correctos y solicito mi cambio de domicilio electoral
                                    </div>
                                    </td>
                            </tr>
                        </tbody>
                    </table>`;

        const { value } = await Swal.fire({
          title:
            "Revise los datos de su solicitud de incorporación al Registro Electoral. Solo luego de su confirmación se iniciará el proceso de revisión de su caso",
          html: htmlConfirm,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          // confirmButtonColor: "#3085d6",
          // cancelButtonColor: "#d33",
          buttonsStyling: false,
          confirmButtonText: "Confirmar su solicitud de incorporación.",
          customClass: {
            cancelButton: "btn btn-outline-gobierno mt-2 w-100",
            confirmButton: "btn btn-gobierno mt-2 w-100",
          },
        });

        if (!value) {
          this.loading = false;
          return;
        }

        this.loading = true;

        const {
          data: { folio, statusCode, error },
        } = await axios.post(url, payload);

        if (error) throw error;

        this.setIncorporacion(true);

        this.setFolio(folio);

        router.push({ path: "/success" });
      } catch (error) {
        console.error("Error al enviar el formulario:: ", error);
        this.loading = false;
        return Swal.fire({
          icon: "error",
          type: "error",
          text: error,
          confirmButtonText: "Aceptar",
        });
      }
    },
  },
};
</script>

<style></style>
